module.exports = __webpack_public_path__ + "assets/img/ftr-app-2.bac13eab.png";